import { render } from "./DanishBankAccount.vue?vue&type=template&id=e1859e54&ts=true"
import script from "./DanishBankAccount.vue?vue&type=script&lang=ts"
export * from "./DanishBankAccount.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__